import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import routes from "../../../routes";
import { getOtp } from "../../../store/selectors/otp";
import { useFormNavigation } from "../../../components/FormNavigation/FormNavigationProvider";
import { ComeBackVerificationComponent } from "../../ComeBackVerification/components/ComeBackVerification";
import { OverlayLoader } from "../../../components/Loader";
import { getProspectInfoPromisify } from "../../../store/actions/retrieveApplicantInfo";
import { getDocumentsList } from "../../../store/actions/uploadDocuments";
import { setRoEFRInvite } from "../../../store/actions/otp";
import { checkIfEfrNotRequiredForNonSignatory } from "../../../utils/checkIfEfrNotRequiredForNonSignatory";
import { updateProspect } from "../../../store/actions/appConfig";
import { useDisplayScreenBasedOnViewId } from "../../../utils/useDisplayScreenBasedOnViewId";
import { EFR_VIEW_IDS, VIEW_IDS_AFTER_CONSENT } from "../../../constants";
import { useTrackingHistory } from "../../../utils/useTrackingHistory";

export const PartnerOTPVerification = () => {
  useFormNavigation([true, false]);
  const { pushDisplayScreenToHistory } = useDisplayScreenBasedOnViewId();
  const pushHistory = useTrackingHistory();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode } = useSelector(getOtp);

  const [loading, setLoading] = useState(false);

  const {
    partnerProspectId,
    mobileNo,
    email,
    sid,
    countryCode,
    redirectToEFR,
    isROInitiated
  } = location.state;

  /* istanbul ignore next */
  const getProspectInfo = useCallback(() => {
    setLoading(true);
    dispatch(getProspectInfoPromisify(partnerProspectId, sid, true)).then(
      prospect => {
        setLoading(false);
        dispatch(getDocumentsList());
        dispatch(
          updateProspect({
            "prospect.userJourneyType": "emailRedirection"
          })
        );
        if (isROInitiated === "Y") {
          dispatch(setRoEFRInvite(true));
        }
        const signatoryDetail = prospect.signatoryInfo.find(
          signatory => signatory.signatoryId === sid
        );
        const isNonSignatoryWithoutEFRJourney = checkIfEfrNotRequiredForNonSignatory(
          signatoryDetail
        );
        if (redirectToEFR) {
          if (EFR_VIEW_IDS.includes(signatoryDetail.viewId)) {
            pushDisplayScreenToHistory(prospect, signatoryDetail);
          } else {
            navigate(routes.stakeholdersInfo);
          }
        } else if (isNonSignatoryWithoutEFRJourney) {
          if (VIEW_IDS_AFTER_CONSENT.includes(signatoryDetail.viewId)) {
            pushDisplayScreenToHistory(prospect, signatoryDetail);
          } else {
            navigate(routes.additionalStakeholderInformation);
          }
        } else {
          navigate(routes.StakeholderTermsAndConditions);
        }
      },
      () => {
        setLoading(false);
        pushHistory(routes.MyApplications, true, {
          searchParam: { mobileNo, email },
          isAuthenticatedSearchRedirect: true
        });
      }
    );
  }, []);

  const partnerInviteProp = {
    getProspectInfo,
    partnerProspectId,
    mobileNo,
    email,
    sid,
    countryCode
  };

  return (
    <div data-testid="partner-otp-verification-wrapper">
      <OverlayLoader open={loading} text={"Loading"} />
      <ComeBackVerificationComponent
        redirectRoute={routes.partnerOTPVerification}
        otpType={mode}
        partnerInviteProp={partnerInviteProp}
      />
    </div>
  );
};
